/* import __COLOCATED_TEMPLATE__ from './escalate-if-needed.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Element: HTMLDivElement;
  Args: { accordion: $TSFixMe; escalationRulesCount: number; escalationGuidanceCount: number };
}

export default class EscalateIfNeeded extends Component<Signature> {
  @service declare appService: AppService;

  get manageEscalationRoute() {
    if (this.hasAccessToEscalationTab()) {
      return this.appService.app.isStandaloneApp
        ? 'apps.app.standalone.escalation'
        : 'apps.app.automation.fin-ai-agent.escalation';
    }

    return this.appService.app.isStandaloneApp
      ? 'apps.app.standalone.guidance'
      : 'apps.app.automation.fin-ai-agent.guidance';
  }

  private hasAccessToEscalationTab() {
    return this.appService.app.canUseFeature('fin-escalation-rules');
  }

  get escalationItemsCount() {
    return this.args.escalationRulesCount + this.args.escalationGuidanceCount;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::EscalateIfNeeded': typeof EscalateIfNeeded;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/escalate-if-needed': typeof EscalateIfNeeded;
  }
}
